app.controller("StudentNewPaymentsController", [
    "$scope", "Students", "SysParam", "$uibModal", "AuthService", "StaticData", "$q", "Payments", "$state", "toastr", "FreshModal",
    function ($scope, Students, SysParam, $uibModal, AuthService, StaticData, $q, Payments, $state, toastr, FreshModal) {
        // $scope.student = {};
        // Payments.history().then(function (data) {
        //     $scope.payments = _.filter(data, {type: 'payment'});
        //     $scope.grants = _.filter(data, {type: 'grant'});
        // });

        // AuthService.getProfiles(function (profiles) {
        //     var currentStudent = _.find(profiles, {type: 'student', state: 'active'});
        //     if (!currentStudent) currentStudent = _.find(profiles, {type: 'student'});
        //     return $scope.student = currentStudent;
        // });

        // StaticData.getItemsByKey("grant_types").then(function (grantTypes) {
        //     $scope.grantTypes = grantTypes;
        //     $scope.grantTypesMap = _.keyBy($scope.grantTypes, '_id');
        // });
        $scope.activeTab = 0;
        $scope.months = {};

        SysParam.getSysParam("financialSeason").then(function (param) {
            var season = param.value.slice(5)
            StaticData.getItemsByKey("months").then(function (data) {
                $scope.months = data[0][season];
            });
        })

        function formatScheduleInfo() {
            $scope.scheduleInfo = Object.keys($scope.months).map(function (month) {
                if ($scope.schedule.hasOwnProperty(month) && $scope.schedule[month] > 0) {
                    var day = ($scope.schedule[month + '_day'] || '').substring(8, 10)
                    day = day ? parseInt(day) : '';
                    return { month: $scope.months[month], amount: $scope.schedule[month], day: day };
                }
                return null;
            }).filter(function (el) { return el; });
        }

        Payments.currentSchedule().then(function (data) {
            $scope.schedule = data;
            formatScheduleInfo();
        }).catch(() => {

            //თუ ხელით გადმოვიდა ამ გვერდზე , ვამოწმებ კიდევ არჩევანს.
            Payments.scheduleList().then(function (data) {
                if (data && data[0].archevani === 0) {
                    AuthService.restore();
                } else if (data && data.length) {
                    $state.go('student-new.payment-schedule');
                }
            });
            // toastr.error('', 'დაფიქსირდა შეცდომა. შეამოწმეთ მოგვიანებით');
        });

        Payments.getPayments().then(function (data) {
            $scope.payments = data;
        });
        Payments.getAccruals().then(function (data) {
            $scope.accruals = data;
        });

        $scope.openInstructions = function () {
            FreshModal.open({
                controller: "StudentPaymentInstructionsController",
                templateUrl: _pb + 'student-new/payment-instructions.html',
            }).then(function (result) {
            }, function (result) {
            });
        };
    }
]);
